import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <motion.span
    className={`block overflow-hidden ${className}`}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true, margin: "-8%" }}
  >
    <motion.span
      className="block will-change-transform"
      variants={{
        hidden: { y: "115%" },
        visible: { y: "0%", transition: { duration: 0.9, ease: EASE, delay } },
      }}
    >
      {children}
    </motion.span>
  </motion.span>
);

export const FadeUp = ({ children, delay = 0, y = 36, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-8%" }}
    transition={{ duration: 0.8, ease: EASE, delay }}
  >
    {children}
  </motion.div>
);

export const MonoLabel = ({ children, className = "" }) => (
  <span
    className={`font-mono text-xs sm:text-sm tracking-[0.25em] uppercase text-muted-foreground ${className}`}
  >
    {children}
  </span>
);
